import { ApolloClient, InMemoryCache } from '@apollo/client';
import { coreApiUrl } from 'shared/utils/http';

export const publicClient = new ApolloClient({
  uri: coreApiUrl,
  cache: new InMemoryCache(),
});
